import { createRouter, createWebHistory } from 'vue-router';
import InicioPagina from './components/InicioPagina.vue';
import BusquedaPacientes from './components/BusquedaPacientes.vue';
import LoginMedicos from './components/LoginMedicos.vue';
import dashboardMedicos from './components/DashboardMedicos.vue';
import slidebar from './components/SlideBar.vue';
import RegistroConsultas from './components/RegistroConsultas.vue';
import CitasMedicas from './components/CitasMedicas.vue';
import ConsultaPrint from './components/ConsultaPrint.vue';
import InfoPacientes from './components/InfoPacientes.vue';
import AdministracionDoctores from './components/AdministracionDoctores.vue';
import AdministradorUsuarios from './components/AdministradorUsuarios.vue';
import AdministracionHoteles from './components/AdministracionHoteles.vue';
import PanelHotel from './components/PanelHotel.vue';
import DashboardAdmin from './components/DashboardAdmin.vue';
import EncuestaSatisfaccion from './components/EncuestaSatisfaccion.vue';
import Terminos from './components/Terminos.vue';
import Privacidad from './components/Privacidad.vue';

const routes = [
  { path: '/', component: InicioPagina },
  { path: '/busqueda', component: BusquedaPacientes },
  { path: '/login', component: LoginMedicos },
  { path: '/dashboard', component: dashboardMedicos, meta: { requiereAuth: true } },
  { path: '/slidebar', component: slidebar, meta: { requiereAuth: false } },
  { path: '/registro', component: RegistroConsultas, meta: { requiereAuth: true } },
  { path: '/citas', component: CitasMedicas, meta: { requiereAuth: true } },
  { path: '/consulta/:folio', component: ConsultaPrint, meta: { requiereAuth: false } },
  { path: '/info/:folio', component: InfoPacientes, meta: { requiereAuth: false } },
  { path: '/admin', component: AdministracionDoctores, meta: { requiereAuth: true, roles: ['administrador', 'jefe'] } },
  { path: '/administrador-usuarios', component: AdministradorUsuarios, meta: { requiereAuth: true, roles: ['administrador', 'jefe'] } },
  { path: '/hoteles', component: AdministracionHoteles, meta: { requiereAuth: true, roles: ['administrador'] } },
  { path: '/panel-hotel', component: PanelHotel, meta: { requiereAuth: true, permiteHotel: true } },
  { path: '/dashboard-admin', component: DashboardAdmin, meta: { requiereAuth: true, roles: ['administrador'] } },
  { path: '/encuesta', component: EncuestaSatisfaccion, meta: { requiereAuth: false } },
  { path: '/terminos', component: Terminos, meta: { requiereAuth: false } },
  { path: '/privacidad', component: Privacidad, meta: { requiereAuth: false } },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  if (!to.meta.requiereAuth) return next();

  const tipoSesion = localStorage.getItem('tipo_sesion');
  const rango = localStorage.getItem('rango');
  const autenticado = !!localStorage.getItem('token') && (tipoSesion === 'medico' || tipoSesion === 'hotel');

  if (!autenticado) return next('/login');

  if (tipoSesion === 'hotel') {
    return to.meta.permiteHotel ? next() : next('/panel-hotel');
  }

  if (to.meta.roles && !to.meta.roles.includes(rango)) {
    return next('/dashboard');
  }

  return next();
});

export default router;
